
import api from './api';

export interface Customer {
    id: number;
    fullName: string;
    phone: string | null;
    email: string | null;
    type: 'NORMAL' | 'MAYORISTA';
    createdAt: string;
    updatedAt: string;
    totalSales?: number;
    lastSale?: string;
    sales?: any[];
}

export interface GetCustomersResponse {
    data: Customer[];
    total: number;
    limit: number;
    offset: number;
}

const customerService = {
    getCustomers: async (params: { limit?: number; offset?: number; search?: string; simple?: boolean }) => {
        const response = await api.get<GetCustomersResponse>('/customers', { params });
        return response.data;
    },

    getCustomerById: async (id: number) => {
        const response = await api.get<Customer>(`/customers/${id}`);
        return response.data;
    },

    createCustomer: async (data: { fullName: string; phone?: string; email?: string; type?: 'NORMAL' | 'MAYORISTA' }) => {
        const response = await api.post<Customer>('/customers', data);
        return response.data;
    },

    updateCustomer: async (id: number, data: { fullName?: string; phone?: string; email?: string; type?: 'NORMAL' | 'MAYORISTA' }) => {
        const response = await api.put<Customer>(`/customers/${id}`, data);
        return response.data;
    },

    getCustomersBalances: async (search?: string) => {
        const response = await api.get<{ success: boolean; data: any[] }>('/customers/balances', { params: { search } });
        return response.data;
    }
};

export default customerService;
